import { TenantRegistrationEdit } from "./TenantRegistrationEdit";
import { TenantRegistrationCreate } from "./TenantRegistrationCreate";
import FolderSpecialOutlinedIcon from "@material-ui/icons/FolderSpecialOutlined";
import { TenantRegistrationsList } from "./TenantRegistrationsList";
import { TenantEldDevicesUsage } from "./TenantEldDevicesUsage";

export default {
  icon: FolderSpecialOutlinedIcon,
  list: TenantRegistrationsList,
  create: TenantRegistrationCreate,
  edit: TenantRegistrationEdit,
  show: TenantEldDevicesUsage,
};

export { TenantEldUsageByEvents } from "./TenantEldUsageByEvents";
export { TenantEldUsageByEventsByDays } from "./TenantEldUsageByEventsByDays";
